import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { useTheme } from 'styled-components';
import { PricingLineContent } from './styles';
const PricingLine = ({ duration, monthlyPrice, yearlyPrice, }) => {
    const theme = useTheme();
    const { t } = useTranslations();
    const getDisplayPrice = () => {
        if (duration === 'one_time') {
            return monthlyPrice;
        }
        else if (duration === 'yearly') {
            return yearlyPrice;
        }
        return monthlyPrice;
    };
    return (_jsxs(PricingLineContent, { children: [_jsx(Typography, { elementTheme: "h3", children: getDisplayPrice() }), duration !== 'one_time' && (_jsx(Typography, { elementTheme: "body3", color: theme.colors.grey_2, children: t('plansDurations|monthly') }))] }));
};
export default PricingLine;
